import { createClient, processLock } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL?.trim();
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY?.trim();

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error(
    'Missing Supabase env vars. Set REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY in .env'
  );
}

// Using untyped client — Database types are defined separately in types/database.types.ts
// for reference. The client operations use 'as any' where needed for type flexibility.
// PKCE must match what GoTrue returns on OAuth redirect (?code=...). Default
// `implicit` causes a flow mismatch and the session is never established.
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    flowType: 'pkce',
    detectSessionInUrl: true,
    persistSession: true,
    autoRefreshToken: true,
    // Default Web Locks + lockAcquireTimeout can "steal" the lock after a wait;
    // the previous holder then throws (common with long auth work + refresh).
    // processLock serializes auth in this tab only without that steal path.
    lock: processLock,
  },
});
